import {
  FeaturePageSlugEnum,
  LegalPageSlugEnum,
  ProductPageSlugEnum,
} from "../types/common.types";

// Products and features are now served at root-level slugs, so their
// "prefix" is empty. Legacy `/products/*` and `/features/*` URLs are 301'd
// to the new paths at the Cloudflare edge.
export const FEATURES_PREFIX = "";
export const PRODUCTS_PREFIX = "";
export const LEGAL_PREFIX = "/legal";

export const ROUTE_PATHS: {
  CREATOR_STORIES: string;
  PRICING: string;
  SIGN_UP: string;
  // PRIVACY: string;
  // TERMS: string;
  // AFFILIATE: string;
  // USER_GUIDELINES: string;
  // REFUND_POLICY: string;
  GET_STARTED: string;
  LEGAL: { [key in keyof typeof LegalPageSlugEnum]: string };
  // PRODUCTS: { [key in ProductPageSlugEnum]: string }; // Generating using value of enum
  PRODUCTS: { [key in keyof typeof ProductPageSlugEnum]: string }; // Generating using key of enum
  // FEATURES: { [key in FeaturePageSlugEnum]: string };
  FEATURES: { [key in keyof typeof FeaturePageSlugEnum]: string };
} = {
  CREATOR_STORIES: "/creators-success-stories",
  GET_STARTED: "/get-started",
  PRICING: "/pricing",
  SIGN_UP: "/signup",
  // PRIVACY: "/legal/privacy",
  // TERMS: "/legal/terms",
  // AFFILIATE: "/affiliate",
  // USER_GUIDELINES: "/user-guidelines",
  // REFUND_POLICY: "/legal/refund-policy",
  LEGAL: Object.entries(LegalPageSlugEnum).reduce(
    (acc, [key, value]) => ({
      ...acc,
      [key]: `${LEGAL_PREFIX}/${value}/`,
    }),
    {}
  ) as { [key in keyof typeof LegalPageSlugEnum]: string },
  PRODUCTS: Object.entries(ProductPageSlugEnum).reduce(
    (acc, [key, value]) => ({
      ...acc,
      [key]: `${PRODUCTS_PREFIX}/${value}`,
    }),
    {}
  ) as { [key in keyof typeof ProductPageSlugEnum]: string },
  FEATURES: Object.entries(FeaturePageSlugEnum).reduce(
    (acc, [key, value]) => ({
      ...acc,
      [key]: `${FEATURES_PREFIX}/${value}`,
    }),
    {}
  ) as { [key in keyof typeof FeaturePageSlugEnum]: string },
};
